import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import VerbButton from '../../../../../../shared/components/VerbButton';
import VerbText from '../../../../../../shared/components/VerbText';
import VerbSelect from '../../../../../../shared/components/formComponents/inputs/VerbSelect';
import TextInput from '../../../../../../shared/components/formComponents/inputs/TextInput';
import CustomRow from './CustomRow';
import {
    CUSTOM_HOME_ROW_TYPES_OBJECT,
    DEFAULT_CUSTOM_HOME_PAGE,
    DEFAULT_CUSTOM_DISCOVER_PAGE
} from '../../../../../../shared/Constants';

export default class CustomHomeTable extends PureComponent {
    static propTypes = {
        fields: PropTypes.object,
        collectionOptions: PropTypes.array,
        handleAddCollectionSection: PropTypes.func,
        isVerbAdmin: PropTypes.bool,
        currentFormValues: PropTypes.object,
        customTab: PropTypes.string,
        globalCollectionRowOptions: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            indexOfDescriptionBeingEdited: 0,
            currentSelectedType: '',
            currentSelectedLabel: '',
            currentSelectedGlobalContentRow: {}
        };
    }

    shouldHideEditables = (type) => {
        const nonConfigurables = [
            'PRESET_DIMENSIONS_SECTION',
            'RECOMMENDED_COLLECTIONS',
            'IN_PROGRESS_SECTION',
            'TEAMS_SECTION',
            'COMPLETED_COLLECTIONS',
            'IMPROVE_YOUR_COMMUNICATION',
            'THINK_LIKE_A_LEADER',
            'ESSENTIAL_MANAGER_SKILLS',
            'POPULAR_ON_PATHS'
        ];

        return nonConfigurables.includes(type);
    };

    _renderDefaultHomePage = () => {
        const { customTab } = this.props;
        const defaultCustomPage =
            customTab === 'customHome'
                ? { categories: DEFAULT_CUSTOM_HOME_PAGE.categories.slice(1) }
                : DEFAULT_CUSTOM_DISCOVER_PAGE;

        const labelText = `A Custom ${
            customTab === 'customHome' ? 'Home' : 'Discover'
        } Page Has Not Been Setup For This Company.`;

        return (
            <>
                <label style={{ marginBottom: 20, marginTop: 20, fontSize: 20 }} className={'form-label'}>
                    {labelText}
                </label>
                <div style={{ marginBottom: 15 }}>
                    <VerbText formatIntl={false} customMessage={'The Following Rows Will Be Displayed By Default:'} />
                </div>
                {defaultCustomPage.categories.map((category) => (
                    <div className={'row default-row'}>
                        <span>{`[Type: ${category.label}]`}</span> &nbsp; &nbsp;
                        {category.label}
                    </div>
                ))}
                <br />
            </>
        );
    };

    _renderTable = (fields) => {
        const { isVerbAdmin, collectionOptions, currentFormValues } = this.props;
        const { isEditing, indexOfDescriptionBeingEdited } = this.state;
            const rowsToRender = [];
            fields.forEach((category, index) => {
                const rowType = get(currentFormValues, `${category}.type`, 'COLLECTION');
                const addCollectionMessage =
                    rowType === 'FEATURED_COLLECTION' ? 'Path in this section' : 'Paths in row';
                const shouldHide = this.shouldHideEditables(rowType);
                if (rowType !== 'PRESET_COLLAB_COLLECTIONS') {
                    rowsToRender.push(
                        <CustomRow
                            index={index}
                            category={category}
                            fields={fields}
                            isVerbAdmin={isVerbAdmin}
                            setEditing={(args) => this.setState({ ...args })}
                            isEditing={isEditing}
                            indexOfDescriptionBeingEdited={indexOfDescriptionBeingEdited}
                            rowType={rowType}
                            shouldHide={shouldHide}
                            addCollectionMessage={addCollectionMessage}
                            collectionOptions={collectionOptions}
                            isFeaturedCollectionRow={rowType === 'FEATURED_COLLECTION'}
                        />
                    );
                }
            });
            return rowsToRender;
    };

    handleAddCollectionSection = () => {
        const { handleAddCollectionSection, fields } = this.props;
        const { currentSelectedLabel, currentSelectedType, currentSelectedGlobalContentRow } = this.state;
        const currentSelectedContent = DEFAULT_CUSTOM_DISCOVER_PAGE.categories.find(c => c.type === currentSelectedType) || {};
        handleAddCollectionSection({
            fields,
            label: currentSelectedLabel,
            type: currentSelectedType,
            ...(currentSelectedType === 'GLOBAL_CONTENT_ROW' ? { ...currentSelectedGlobalContentRow } : currentSelectedContent)
        });

        this.setState({
            currentSelectedLabel: '',
            currentSelectedType: currentSelectedType === 'GLOBAL_CONTENT_ROW' ? currentSelectedType : '',
            currentSelectedGlobalContentRow: {}
        });
    };

    _makeGlobalCollectionRowOptions = () => {
        const { globalCollectionRowOptions } = this.props;
        return Object.keys(globalCollectionRowOptions).map((key) => {
            const { label, _id } = globalCollectionRowOptions[key];
            return { label, value: 'GLOBAL_CONTENT_ROW', id: _id };
        });
    };

    _handleTypeChange = (e) => {
        const { globalCollectionRowOptions } = this.props;
        const currentSelectedType = e ? e.value : '';
        let selectedLabel = '';
        let currentSelectedGlobalContentRow = {};
        if (
            CUSTOM_HOME_ROW_TYPES_OBJECT[currentSelectedType] &&
            CUSTOM_HOME_ROW_TYPES_OBJECT[currentSelectedType].value !== 'COLLECTION'
        ) {
            selectedLabel = CUSTOM_HOME_ROW_TYPES_OBJECT[currentSelectedType].label;
        }
        if (CUSTOM_HOME_ROW_TYPES_OBJECT[currentSelectedType].value === 'GLOBAL_CONTENT_ROW') {
            currentSelectedGlobalContentRow = globalCollectionRowOptions[e.id];
        }
        this.setState({ currentSelectedType, currentSelectedLabel: selectedLabel, currentSelectedGlobalContentRow });
    };

    _setRowTypeExclusions = (customTab) => {
        const excludeOptionsDict = {
            PRESET_JUST_RELEASED: false,
            PRESET_COLLAB_COLLECTIONS: false
        };

        if (customTab === 'customDiscover') {
            excludeOptionsDict.FEATURED_COLLECTION = true;
        }

        if (customTab === 'customHome') {
            excludeOptionsDict.PRESET_JUST_RELEASED = true;
        }

        return excludeOptionsDict;
    };

    _makeRowTypeOptions = () => {
        const { currentFormValues, customTab } = this.props;
        const excludeOptionsDict = this._setRowTypeExclusions(customTab);
        (
            (currentFormValues &&
                currentFormValues[`${customTab} `] &&
                currentFormValues[`${customTab} `].categories) ||
            []
        ).forEach((item) => {
            if (item.type !== 'COLLECTION') {
                excludeOptionsDict[item.type] = true;
            }
        });
        return [CUSTOM_HOME_ROW_TYPES_OBJECT['COLLECTION']];
    };

    render() {
        const { fields, customTab = 'customDiscover' } = this.props;
        const { currentSelectedType, currentSelectedGlobalContentRow, currentSelectedLabel } = this.state;
        const homePageName = customTab === 'customDiscover' ? 'Discover' : 'Home';
        return (
            <div>
                <div>
                    <label className={'form-description light'}>
                        {`To create a new row, select custom row for row type, insert a title for the custom row, and then add row. Optional: Include a short description to display under the row title. After creating a row, add Paths.`}
                    </label>
                    <br />

                    <div className={'row'}>
                        <div className={'col-4'}>
                            <VerbSelect
                                placeholder={'Select Row Type'}
                                className={'reactSelect'}
                                value={currentSelectedType || ''}
                                labelKey={'label'}
                                valueKey={'value'}
                                onChange={this._handleTypeChange}
                                options={this._makeRowTypeOptions()}
                            />
                        </div>
                        {currentSelectedType === 'GLOBAL_CONTENT_ROW' && (
                            <div className={'col-4'}>
                                <VerbSelect
                                    placeholder={'Select Global Collection Row'}
                                    className={'reactSelect'}
                                    value={
                                        isEmpty(currentSelectedGlobalContentRow)
                                            ? null
                                            : currentSelectedGlobalContentRow
                                    }
                                    labelKey={'label'}
                                    valueKey={'value'}
                                    onChange={this._handleTypeChange}
                                    options={this._makeGlobalCollectionRowOptions()}
                                />
                            </div>
                        )}
                        {currentSelectedType !== 'GLOBAL_CONTENT_ROW' && (
                            <div className={'col-4'}>
                                <TextInput
                                    componentClass={'textarea'}
                                    onChange={(e) => {
                                        this.setState({ currentSelectedLabel: e.target.value });
                                    }}
                                    value={currentSelectedLabel || ''}
                                    rows={1}
                                    maxLength={'100'}
                                    placeholder={'Add title for custom row'}
                                    type={'text'}
                                    disabled={
                                        !currentSelectedType.length || this.shouldHideEditables(currentSelectedType)
                                    }
                                />
                            </div>
                        )}
                        <div className={'custom-home-button col-4'}>
                            <VerbButton
                                className={'full-width'}
                                fontAwesomeIcon={'fa-plus'}
                                onClick={() => this.handleAddCollectionSection()}
                                buttonText={'ADD ROW'}
                                disabled={!currentSelectedType.length}
                            />
                        </div>
                    </div>
                </div>
                <br />
                {this._renderTable(fields)}
            </div>
        );
    }
}
